export enum AppNotificationTab {
  Everything = 1,
  Messages = 2,
  Mentions = 3,
  System = 4,
  Saved = 5,
}